export const handleComplexTrackNumber = (ele) => {
  try {
    const str = String(ele);
    const isIncludeDot = str.includes('.');

    if (!isIncludeDot) {
      return str;
    }
    const splitStr = str.split('.');
    const lastPart = splitStr.pop().slice(0, 2);

    return `${splitStr.join('.')}.${lastPart}`;
  } catch {
    return '-';
  }
};

export const a = '';
